import { useEffect } from "react";

const SITE = process.env.REACT_APP_SITE_URL;
export const BRAND = "The Desi Science Page";

const setTag = (selector, create, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(create.tag);
    Object.entries(create.attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const meta = (key, value, prop = false) => {
  const a = prop ? "property" : "name";
  setTag(`meta[${a}="${key}"]`, { tag: "meta", attrs: { [a]: key } }, "content", value);
};

export const Seo = ({ title, description, path = "/", image = "/og-image.jpg", type = "website", jsonLd }) => {
  useEffect(() => {
    const url = `${SITE}${path}`;
    const img = `${SITE}${image}`;
    document.title = title;
    meta("description", description);
    setTag('link[rel="canonical"]', { tag: "link", attrs: { rel: "canonical" } }, "href", url);
    meta("og:type", type, true);
    meta("og:title", title, true);
    meta("og:description", description, true);
    meta("og:url", url, true);
    meta("og:image", img, true);
    if (image === "/og-image.jpg") {
      meta("og:image:width", "1200", true);
      meta("og:image:height", "630", true);
    } else {
      document.head.querySelectorAll('meta[property="og:image:width"], meta[property="og:image:height"]').forEach((m) => m.remove());
    }
    meta("og:image:alt", title, true);
    meta("twitter:title", title);
    meta("twitter:description", description);
    meta("twitter:image", img);
    let script = null;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.route = "1";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
  }, [title, description, path, image, type, jsonLd]);
  return null;
};

export const siteUrl = (p) => `${SITE}${p}`;
